import React from 'react';
import bem from 'utils/bem';
import Icon from 'components/Icon';
import Text from 'components/Text';
import './index.sass';

const { block, el } = bem('download-item');
export const DownloadItem = ({ title, link, name = 'download-simple', ...props }) => {
    return (
        <a className={ block() } target='_blank' href={ link }>
            <Text>{ title }</Text>
            <div className={ el('icon') }>
                <Icon name={ name }/>
            </div>
        </a>
    )
}
